import { ButtonProps } from '@chakra-ui/react';

export const closeBtn: ButtonProps = {
  variant: 'unstyled',
  position: 'absolute',
  top: [0, null, '10px'],
  right: [0, null, '14px'],
  boxSize: '10',
  color: 'gamma.600',
  sx: {
    svg: {
      boxSize: ['20px', null, '20px'],
      color: 'gamma.600',
      fill: 'gamma.600',
      stroke: 'alpha.300',
    },
  },
};
